module.exports = __webpack_public_path__ + "img/1539890861.79243b19.jpg";